module.exports = __webpack_public_path__ + "static/media/IntiveFriend.cb61840e.svg";